"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.directionsType = exports["default"] = void 0;
var directions = {
  top: 'top',
  right: 'right',
  bottom: 'bottom',
  left: 'left',
  topStart: 'top-start',
  topEnd: 'top-end',
  bottomStart: 'bottom-start',
  bottomEnd: 'bottom-end',
  leftStart: 'left-start',
  leftEnd: 'left-end',
  rightStart: 'right-start',
  rightEnd: 'right-end'
};
var directionsType = Object.values(directions);
exports.directionsType = directionsType;
var _default = directions;
exports["default"] = _default;